export enum InvestmentExperience {
    Ie1 = 1,
    Ie2 = 2,
    Ie3 = 3,
    Ie4 = 4,
    Ie5 = 5,
}
